// @flow
import React from 'react'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Snackbar from '@material-ui/core/Snackbar'
import TextField from '@material-ui/core/TextField'
import { compare } from 'er2_web_utils'
import { getLayers, getLayer } from 'catena/er2_map_userlayers/js/utils'
import * as ids from '../constants/ids'
import * as actionTypes from '../constants/action_types'
import { getActiveTool, matchesSelectedGeometryType } from '../components/geo_bar_panel'
import { validationError } from '../actions/form'

type Props = {
    actions: {
        onChangeInput: Function,
        onClickInlineHelp: Function,
        onGeoBarFetchErrorRendered: Function,
        onGeoBarResultRendered: Function,
        onGeoBarSubmitDissolve: Function,
        onGeoBarSelectLayer: Function,
    },
    mapsources: {},
    theme?: {},
}

function isValid(tool) {
    return tool.layers.length > 0 && tool.key.length > 0
}

function dissolve(props) {
    const tool = getActiveTool(props)
    const layers = getLayers(props.mapsources)
    props.actions.onGeoBarSubmitDissolve(layers.filter(lyr => tool.layers.includes(lyr.id)), tool.key)
}

function isValidKey(key: number, dispatch, getState) {
    if (!key.length) {
        const error = { id: ids.GEO_BAR_DISSOLVE, type: actionTypes.VALIDATION_ERROR_INVALID_FIELD, message: 'Please provide a valid key' }
        dispatch(validationError(error))
        return false
    }
    return true
}

class GeoBarDissolve extends React.Component<Props> {
    renderNotifications(theme) {
        const layerName = this.state.result ? this.state.layerName : ''
        const message = layerName ? `Result saved to ${layerName}` : 'No result found for this operation'
        return (<div>
            <Snackbar
                open={tool.resultRendered === false}
                autoHideDuration={6000}
                onClose={() => {
                    this.props.actions.onGeoBarResultRendered(tool.id)
                    if (this.props.actions.onUpdateUserLayers) this.props.actions.onUpdateUserLayers()
                }}
                message={<span id="message-id">{message}</span>}
            />
            <Snackbar
                open={tool.fetchError}
                autoHideDuration={6000}
                onClose={() => this.props.actions.onGeoBarFetchErrorRendered(tool.id)}
                message={<span id="message-id">Error performing operation</span>}
            />
        </div>)
    }

    renderTool(theme) {
        const tool = getActiveTool(this.props)
        const layers = getLayers(this.props.mapsources)
        return (<React.Fragment>
            <label className={theme.subHeaderLabel}>Layers</label>
            <div className={theme.layersListCtr}>
                {layers.filter(lyr => lyr.layer_type && lyr.layer_type.toLowerCase() !== 'raster').sort((a, b) => compare(a.name, b.name)).map(layer => (
                    <div className={theme.layerGroup} key={layer.id}>
                        <label className={theme.label}>{layer.name}</label>
                        <Checkbox
                            disabled={!matchesSelectedGeometryType(layer, tool.layers, layers)}
                            onChange={(event, isChecked) => this.props.actions.onGeoBarSelectLayer(isChecked, layer, tool)}
                            checked={tool.layers.includes(layer.id)}
                        />
                    </div>
                ))}
            </div>
            <div className={theme.controlGroup}>
                <TextField
                    id={ids.GEO_BAR_DISSOLVE_KEY}
                    required
                    className={theme.textField}
                    label="Attribute Name"
                    value={tool.key}
                    onChange={evt => this.props.actions.onChangeInput(evt.target.value, ids.GEO_BAR_DISSOLVE_KEY)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                />
            </div>
            <div className={theme.formGroup}>
                <Button
                    classes={{
                        root: theme.buttonSubmit,
                    }}
                    disabled={!isValid(tool)}
                    onClick={() => dissolve(this.props)}
                >
                    {!tool.isFetching &&
                    <span>Submit</span>
                    }
                    {tool.isFetching &&
                    <span>Running&nbsp;<i className="fa fa-refresh fa-spin" /></span>
                    }
                </Button>
            </div>
        </React.Fragment>)
    }

    render() {
        const theme = this.props.theme
        const tool = getActiveTool(this.props)
        const helpActive = tool.helpActive

        return (<div className={theme.geoBarCtr}>
            <div className={theme.formGroup}>
                <label className={theme.toolLabel}>Dissolve Tool</label>
                <i
                    className={`${theme.helpIcon}
                    ${helpActive ? theme.helpIconActive : ''}
                    fa fa-question-circle`}
                    onClick={() => this.props.actions.onClickInlineHelp(ids.GEO_BAR_DISSOLVE)}
                    role="button"
                    tabIndex={0}
                />
            </div>
            {helpActive &&
            <div className={theme.helpInlineCtr}>
                <div className={theme.helpInline}>
                    <p>
                        Dissolve two or more user layers together.
                    </p>
                    <p>
                        To perform a dissolve, click the checkbox next to two or more layers and then select a key.
                        The key is the name of any database attribute that all layers share together.  Then click on
                        Submit.  A dissolve will be performed on the selected layers, and the result will be added
                        to your user layers (above).
                    </p>
                </div>
            </div>
            }
            <div className={theme.toolCtr}>
                {this.renderTool(theme)}
            </div>
            {this.renderNotifications(theme)}
        </div>)
    }
}

export default GeoBarDissolve
